import Sider from "antd/es/layout/Sider";
import React from "react";
import {PlanNode} from "../../api/crawler";
import {Tabs} from "antd";
import {ObjectSchema, PageType} from "../../api/config";
import {LaunchCrawlerTab} from "./tabs/DebugLaunchTab";
import {PlanTreeViewTab} from "./tabs/PlanTreeViewTab";


export interface SelectedItem {
    pageTypeID: number
    schemaSlug: string
    crawlConfigSchema: ObjectSchema | null
    urls: string[]
}


interface Sider2Props {
    siteID: number
    objectSchemas: Record<string, ObjectSchema>
    crawlPlan: PlanNode[]
    onSelect?: (selection: SelectedItem) => void
    pageTypes: PageType[]
    onReloadCrawlPlan: () => void
}


export function LeftColumn({siteID, objectSchemas, crawlPlan, onSelect, pageTypes, onReloadCrawlPlan}: Sider2Props) {
    return <Sider collapsible={true} collapsedWidth={100} reverseArrow={false} width={300}
                  className="site-layout-background sider" style={{
        overflow: "hidden",
        backgroundColor: "rgb(240, 242, 245)",
        paddingLeft: "10px",
        paddingTop: "10px"
    }}>
        <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="План обхода" key="1">
                <PlanTreeViewTab siteID={siteID} objectSchemas={objectSchemas} crawlPlan={crawlPlan} onSelect={onSelect}
                                 pageTypes={pageTypes} onReloadCrawlPlan={onReloadCrawlPlan}/>

            </Tabs.TabPane>
            <Tabs.TabPane tab="Тестовый прогон" key="2">
                <LaunchCrawlerTab site_id={siteID}/>
            </Tabs.TabPane>
        </Tabs>
    </Sider>
}